/**
 * What the server keeps of a supplier and its conditions (backend `ValidationHelper`, `SupplierLocation.MAX`,
 * `SupplierConditionsWire`, `RequestedPrices`, `MachineWeights`), so the forms refuse it before the save does. No
 * imports: the rule makers take the caller's `t`.
 */

/** A name, phone number, e-mail, website, customer number, freight or tariff note (`bigStringMaxLength`). */
export const TEXT_MAX = 250
/** A supplier's or a Standort's note (`largeStringMaxLength`). */
export const NOTE_MAX = 555
/** Standorte per supplier. */
export const MAX_LOCATIONS = 50
/** The longest time unit a transport by time is billed in, in minutes: four hours. */
export const MAX_MINUTES_PER_UNIT = 240
/** Skonto within this many days. */
export const MAX_CASH_DISCOUNT_DAYS = 365
/** The highest bound of a transport weight class, in tons. */
export const MAX_CLASS_TONS = 1000
/** The years a dated price, discount or tariff may hold from. */
export const FIRST_YEAR = 2000
export const LAST_YEAR = 2100

/** Required, and more than blanks: the server refuses a name of spaces (`@NotBlank`). */
export const requiredText = t => value => Boolean(String(value ?? "").trim()) || t("validation.required")

/** At most `max` characters as sent; empty is fine. */
export const atMost = (max, message) => value => !value || String(value).length <= max || message
